import {
  MERCHANT_DATA,
  PURCHASE_ORDER_DATA,
  PURCHASE_ORDER_NUMBER,
  USER_LOGOUT,
  EMPLOYEE_CLOCKIN_RANGE,
  EMPLOYEE_ID_FOR_CLOCKINREPORT,
  EMPLOYEE_CLOCKIN_DATE,
  EMPLOYEE_NAME,
  CLOCKINOUT_DATE,
  PURCHASE_ORDER_PLACE_DATA,
  CHECK_ORDER_DATA,
  CUSTOMER_ORDER_DATA,
  SALES_ORDER_STATUS,
} from "../constants";
const initialState = {
  merchantData: {},
  orderData: {},
  orderPlaceData: [],
  orderNumber: {},
  empClockInDate: {},
  empClockInRange: [],
  empIdForReport: {},
  empName: {},
  clockInOutDate: {},
  isOrderValue: false,
  customerOrderData: [],
  orderStatus: {},
};
const merchantReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MERCHANT_DATA:
      return { ...state, merchantData: payload };
    case USER_LOGOUT:
      return {
        customerOrderData: [],
        orderStatus: {},
        merchantData: {},
        orderData: {},
        orderNumber: {},
        empClockInDate: {},
        empClockInRange: [],
        orderPlaceData: {},
        empIdForReport: {},
        empName: {},
        clockInOutDate: {},
      };

    case CUSTOMER_ORDER_DATA:
      if (Array.isArray(payload) && payload.length === 0) {
        return { ...state, customerOrderData: [] };
      } else {
        const newItems = payload.map((item) => ({
          _id: item._id,
          orderType: item.orderType ? item.orderType : "Product",
          orderLineId: item.orderLineId,
          orderQuantity: item.orderQuantity,
          itemName: item.itemName,
          upc: item.upc,
          departmentName: item?.departmentId?.departmentName
            ? item?.departmentId?.departmentName
            : item?.departmentName,
          costPrice: item.costPrice,
          price: item.price,
          check: true,
          isOneDollarReward: item.isOneDollarReward,
          taxStrategy: item.taxStrategy,
          appliedTaxAmount: 0,
          grossProfit: item.grossProfit,
          gpPercentage: item.gpPercentage,
        }));
        // Filter out items that are no longer present in the new payload
        const updatedItems = state.customerOrderData.filter((existingItem) => {
          return newItems.some(
            (newItem) =>
              existingItem._id === newItem._id &&
              existingItem.orderLineId === newItem.orderLineId &&
              existingItem.upc === newItem.upc
          );
        });
        // Update quantities for existing items
        const updatedExistingItems = updatedItems.map((existingItem) => {
          const newItem = newItems.find(
            (newItem) =>
              existingItem._id === newItem._id &&
              existingItem.orderLineId === newItem.orderLineId &&
              existingItem.upc === newItem.upc
          );
          if (newItem) {
            return {
              ...existingItem,
              orderQuantity: newItem.orderQuantity,
              price: newItem.price,
              grossProfit: newItem.grossProfit,
              gpPercentage: newItem.gpPercentage,
            };
          } else {
            return existingItem;
          }
        });
        // Add new items that are not already present in the state
        const newItemsToAdd = newItems.filter(
          (newItem) =>
            !state.customerOrderData.some(
              (existingItem) =>
                existingItem._id === newItem._id &&
                existingItem.orderLineId === newItem.orderLineId &&
                existingItem.upc === newItem.upc
            )
        );
        return {
          ...state,
          customerOrderData: [...updatedExistingItems, ...newItemsToAdd],
        };
      }
    case SALES_ORDER_STATUS:
      return { ...state, orderStatus: payload };
    case PURCHASE_ORDER_DATA:
      return { ...state, orderData: payload };
    case PURCHASE_ORDER_PLACE_DATA:
      return { ...state, orderPlaceData: payload };
    case CHECK_ORDER_DATA:
      return { ...state, isOrderValue: payload };
    case PURCHASE_ORDER_NUMBER:
      return { ...state, orderNumber: payload };
    case EMPLOYEE_CLOCKIN_RANGE:
      return { ...state, empClockInRange: payload };
    case EMPLOYEE_CLOCKIN_DATE:
      return { ...state, empClockInDate: payload };
    case EMPLOYEE_ID_FOR_CLOCKINREPORT:
      return { ...state, empIdForReport: payload };
    case EMPLOYEE_NAME:
      return { ...state, empName: payload };
    case CLOCKINOUT_DATE:
      return { ...state, clockInOutDate: payload };
    default:
      return state;
  }
};
export default merchantReducer;
